import { useState, useCallback } from "react";
import { Menu } from "lucide-react";
import { useAuth } from "../contexts";
import Sidebar from "./Sidebar";
import NotificationCenter from "./NotificationCenter";
import LanguageSwitcher from "./LanguageSwitcher";

const MainLayout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user } = useAuth();
  const [wsConnected, setWsConnected] = useState(false);
  const handleConnectionChange = useCallback((connected) => setWsConnected(connected), []);

  return (
    <div className="min-h-screen bg-gray-100">
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} wsConnected={wsConnected} />

      <div className="lg:ml-64">
        <header className="lg:hidden bg-white shadow-sm p-4 flex items-center justify-between">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 hover:bg-gray-100 rounded-lg"
          >
            <Menu size={24} />
          </button>
          <div className="flex items-center gap-1">
            <span className="text-xl font-bold">Lo</span>
            <span className="text-xl font-bold text-lojack-red">/</span>
            <span className="text-xl font-bold">Jack</span>
          </div>
          <div className="flex items-center gap-2">
            <NotificationCenter user={user} onConnectionChange={handleConnectionChange} />
            <LanguageSwitcher />
          </div>
        </header>

        <div className="hidden lg:flex justify-end items-center gap-4 p-4 pb-0">
          <NotificationCenter user={user} onConnectionChange={handleConnectionChange} />
          <LanguageSwitcher />
        </div>

        <main className="p-4 lg:p-8 lg:pt-4">{children}</main>

        <footer className="p-4 text-center border-t bg-white mt-8">
          <a
            href="https://telcavoip.ai"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 transition"
          >
            <span>Powered by</span>
            <span className="font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">TelcaVoIP AI</span>
          </a>
        </footer>
      </div>
    </div>
  );
};

export default MainLayout;
